import axios from 'axios'
import { Notify, Dialog } from 'vant'
import store from './../store'
import md5 from 'js-md5'
import router from '../router'
import { isWeiXin } from './utils'

const http = axios.create({
  timeout: 15000 // 请求超时
})

http.interceptors.request.use(
  requestConfig => {
    const token = store.state.user.token
    if (token) {
      requestConfig.headers.Authorization = store.state.user.token
    }
    return requestConfig
  },
  error => Promise.reject(error)
)
let flag = false
http.interceptors.response.use(
  resp => {
    // console.log(store.state.user.userInfo)
    if (resp.data.status === 99101 || resp.data.status === 40301) {
      if (isWeiXin()) {
        if (!flag) {
          flag = true
          Notify(resp.data.message)
          RouteJump(2000)
          flag = false
        }
        return resp
      } else {
        return resp
      }
    } else if (resp.data.status === 44001) {
      // 出现弹框提示
      Dialog.confirm({
        title: '温馨提示',
        message: '不支持访问\n 如有疑问可拨打客服热线\n 400-0940-898',
        confirmButtonText: '我知道了',
        confirmButtonColor: '#000000',
        showCancelButton: false,
        className: 'Dialog'
      })
        .then(() => {
          router.push('/')
        })
        .catch(() => {})
      return resp
    } else {
      return resp
    }
  },
  error => {
    window.console.error(error)
  }
  // error => Promise.reject(error)
)

export default http

export function get(url, params = {}) {
  return http({
    method: 'get',
    url,
    params
  })
}

export function getSign(url, params = {}) {
  const timestamp = new Date().getTime()
  const signSecretkey = 'xjfmobile'
  const sign = md5(timestamp + signSecretkey)
  return http({
    method: 'get',
    url,
    params,
    headers: { timestamp: timestamp, sign: sign }
  })
}

export function post(url, data = {}, params = {}) {
  return http({
    method: 'post',
    url,
    data,
    params
  })
}

export function put(url, data = {}, params = {}) {
  return http({
    method: 'put',
    url,
    data,
    params
  })
}

export function _delete(url, params = {}) {
  return http({
    method: 'delete',
    url,
    params
  })
}
function RouteJump(Time) {
  store.dispatch('resultsToken')
  store.dispatch('resultsUserInfo')
  setTimeout(() => {
    // flag = false
    // let params = window.location.search
    // params = params.replace(/&code=/, '&code1=') //code可能重复获取
    // let url = window.location.pathname + params
    // router.push('/login?redirectUrl=' + url)
  }, Time)
}
